import React, { forwardRef, useImperativeHandle } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const SnackbarComponent = forwardRef(({ confirmMessage }, ref) => {
  const [open, setOpen] = React.useState(false);
   const [message, setMessage] = React.useState("");
  confirmMessage ??= "Action performed successfully";
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  useImperativeHandle(ref, () => ({
    setOpenSnackBar: (customMessage) => {
      // Agar custom message pass ho to wo use karo, warna default confirmMessage
      setMessage(customMessage || confirmMessage);
      setOpen(true);
    },
  }));
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
        vertical="top"
        horizontal="right"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message={message || confirmMessage}
        action={action}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
});

export default SnackbarComponent;
